<script>
    import { client, gql } from "../GraphQL.svelte";
    import Notification from "./Notification.svelte";

    export let email;

    let request;
    let successMsg = "";
    let errMsg = "";

    function handle() {
        request = client.mutate({
            mutation: gql`
                mutation($emailAddress: String!) {
                    forgotPassword(emailAddress: $emailAddress)
                }
            `,
            variables: { emailAddress: email }
        })

        .then(res => {
            successMsg = "If an account exists with the given email address, a password reset email was successfully sent";
            request = null;
        })

        // TODO: not authorized (!?)
        .catch(err => {
            //debugger;
            errMsg = `There was an error sending the password reset email: ${err}`;
            request = null;
        });
    }
</script>

{#if !request}
    <a href="#" class="forgot-password-link" on:click={handle}>forgot password?</a>
{:else}
    <a href="#" class="forgot-password-link" on:click={handle}>...</a>
{/if}

<Notification message={successMsg} type="success" />
<Notification message={errMsg} type="error" />

<style>
    a {
        display: block;
        text-align: right;
        color: #107afe;
        margin-top: 10px;
        font-size: 80%;
    }
</style>